// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__16B7g","notes":"Notes_notes__lTdtF","note":"Notes_note__3F3H3","markdown":"Notes_markdown__TFCRr"};